<template>
  <label :for="id" class="select-label" />
  <select :id="id" v-model="selectedValue" @change="handleChange" class="select" v-if="!disabled">
    <option
      v-for="option in options"
      :key="option.value"
      :value="option.value"
      :disabled="disabled"
    >
      {{ option.label }}
    </option>
  </select>
  <input :value="selectedOptionLabel" :disabled="true" class="select" v-if="disabled" />
</template>

<script>
export default {
  name: 'DropdownSelect',
  props: {
    id: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectedValue: this.modelValue,
    };
  },
  computed: {
    selectedOptionLabel() {
      if (this.selectedValue !== null && this.options.length > 0) {
        const selectedOption = this.options.find((opt) => opt.value === this.selectedValue);
        return selectedOption ? selectedOption.label : '';
      }
      return '';
    },
  },
  watch: {
    modelValue(newValue) {
      this.selectedValue = newValue;
    },
    options: {
      deep: true,
      handler() {
        this.updateSelectedValue(this.selectedValue);
      },
    },
  },
  methods: {
    handleChange(event) {
      const val = parseInt(event.target.value, 10);
      this.$emit('update:modelValue', val);
      this.$emit('change', val);
    },
    updateSelectedValue(newValue) {
      const foundOption = this.options.find((option) => option.value === newValue);
      if (foundOption) {
        this.selectedValue = foundOption.value;
      } else if (this.options.length > 0) {
        this.selectedValue = this.options[0].value;
      } else {
        this.selectedValue = 0;
      }
    },
  },
};
</script>

<style scoped>
.select {
  flex: 1;
  padding: 10px;
  width: 100%;
  font-size: 20px;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 3px;
  background: white;
}
.select-label {
  display: none;
}

@media (max-width: 600px) {
  .select {
    width: 100%;
  }
}
</style>
